export const ROUTES = {
  APP: 'app-index',
  LOGIN: 'login',
  COMPANY: 'company',
  COMPANY_EDIT: 'company/edit',
  COMPANY_INFO: 'company/info',
  CREATION_REQUESTS: 'creation-requests',
  NOTIFICATIONS_POC: 'fcm-poc',
}
